import { useState, useEffect } from 'react';
import { fieldValidator } from '../../utils/yupSchemaCreator';
import { DatePicker, FormControl } from '@airbus/components-react';
import { isDateValid } from '../../utils';

export default function FieldDate(props) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    handleEnterTabBlur,
  } = props;
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);
  const minDates = field?.col_min_value ? new Date(field?.col_min_value, 1, 1) : null;
  const maxDates = field?.col_max_value ? new Date(field?.col_max_value, 12, 31) : null;

  useEffect(() => {
    if (initialValues) {
      const isValid = isDateValid(initialValues[name]);
      if (!isValid) {
        setValue(null);
      } else {
        setValue(initialValues[name]);
      }
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }
      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }
    }
  }, [initialValues]);

  const handleChange = (newValue) => {
    const error = fieldValidator(field, newValue, language);
    setValue(newValue);
    setError(error);
    setTouched(true);
  };

  const handleBlur = () => {
    if (initialValues[name] === value) {
      return;
    }
    blurHandler(name, error?.type == 'invalid' ? null : value ?? null);
    if (field?.onValueChange) {
      field.onValueChange({ rowId, value, row: initialValues });
    }
  };

  return (
    <FormControl
      id={name}
      error={touched && Boolean(error)}
      {...{ label, name, required, disabled }}
      helpText={touched && error?.msg}
      errorText={touched && error?.msg}
      onBlur={handleBlur}
      onKeyDown={handleEnterTabBlur}
      className='input-small disabled-input'
    >
      <DatePicker
        value={value ? new Date(value) : null}
        disabled={disabled}
        dateFormat='DD/MM/YYYY'
        onChange={(val) => handleChange(val)}
        minDate={minDates}
        maxDate={maxDates}
        onBlur={handleBlur}
        datePattern='[0-9]{2}/[0-9]{2}/[0-9]{4}'
        dateSeparator='/'
        onKeyDown={handleEnterTabBlur}
      />
    </FormControl>
  );
}
